import { Payment } from '.'

export class ExpenseOrder extends Payment {

}
